<app-side-navigation-bar></app-side-navigation-bar>
<app-sidebar></app-sidebar>
<app-headbar></app-headbar>


<div class="bb-main-container">
  <h2 class="mb-4">Beep-Bop</h2>
  <iframe frameBorder="0"class="full" src="https://snatchbot.me/webchat?botID=47554&appID=wc04Gc5xv6T88betxap4"></iframe>
  </div>